const firebaseConfig = {
    apiKey: "AIzaSyDf7zJ4mVcY_nUQ4oWkqdc2MGAc87F1PfY",
    authDomain: "mogged-mvp-dev.firebaseapp.com",
    databaseURL: "https://mogged-mvp-dev-default-rtdb.firebaseio.com",
    projectId: "mogged-mvp-dev",
    storageBucket: "mogged-mvp-dev.firebasestorage.app",
    messagingSenderId: "76832623784",
    appId: "1:76832623784:web:42defa4d26bdfabeb6869d",
    measurementId: "G-HRGHL4GPNX",
    // App Check reCAPTCHA v3 site key (public, safe to commit). Empty = App
    // Check init is skipped. Fill after registering the app in the Firebase
    // console (App Check → reCAPTCHA v3). See src/firebase/Init.js.
    appCheckSiteKey: "6Lf54EEtAAAAACUTYGosZ7aPzqFQNFJ2Rp0lGqXr"
  };

export default firebaseConfig;